import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import styled from 'styled-components';
import { startCase } from 'lodash';
import moment from 'moment';

import Empty from '../../components/common/Empty';
import Link from '../../components/common/Link';
import * as MembershiPlansActionCreators from '../../redux/membership';
import * as UiActionsCreators from '../../redux/ui';
import { SHOWING_FIELDS_MEMBERSHIPLANS } from '../../constants';

const TableContainer = styled.div`
  background-color: #eeeeee;
  padding: 20px;
`;

const TablePaper = styled(Paper)`
  && {
    width: 100%;
    margin-top: 30px;
    overflow-x: auto;
  }
`;

const EventsTable = styled(Table)`
  && {
    min-width: 700px;
  }
`;

const EventsTableHead = styled(TableHead)`
  && {
    background-color: rgba(125, 188, 255, 0.6);
  }
`;

const EventsTableHeadFields = styled(TableCell)`
  && {
    color: black;
    font-weight: bold;
  }
`;

const EditButtonContainer = styled.div`
  margin-top: 5px;
`;

const SearchButton = styled(Button)`
  && {
    margin-left: 20px;
  }
`;

class MemberShipPage extends Component {
  state = {
    searchField: null,
    order: 'asc',
    orderBy: null
  };

  componentDidMount() {
    const { actions } = this.props;
    actions.getMemberShipPlans();
  }

  onClickSearchEvent = () => {
    const { actions } = this.props;
    actions.getMemberShipPlans(
      this.state.orderBy,
      this.state.order,
      this.state.searchField
    );
  };

  onEnter = e => {
    if (e.key === 'Enter') {
      this.onClickSearchEvent();
    }
  };

  onClickSortHandle = orderBy => event => {
    const { actions } = this.props;
    const order = this.state.order === 'asc' ? 'desc' : 'asc';
    this.setState({ orderBy, order });

    actions.getMemberShipPlans(orderBy, order, this.state.searchField);
  };

  onChangeSearch = value => this.setState({ searchField: value });

  getCellNames = () => {
    return [
      'id',
      'name',
      'url',
      'organization_name',
      'count',
      'requires_approval',
      'price',
      'auto_renewal',
      'type'
    ];
  };
  renderTableCellNames = () => {
    const cellNames = this.getCellNames();
    return cellNames.map((name, i) => {
      if (SHOWING_FIELDS_MEMBERSHIPLANS.includes(name)) {
        const displayName = startCase(name);
        return (
          <EventsTableHeadFields key={i}>{displayName}</EventsTableHeadFields>
        );
      }
      return null;
    });
  };

  renderTableBody = () => {
    const { membershiplans } = this.props;

    if (!membershiplans) return <TableRow />;
    const cellNames = this.getCellNames();
    return membershiplans.map((plan, i) => {
      return (
        <TableRow key={i}>
          {cellNames.map((field, index) => {
            if (SHOWING_FIELDS_MEMBERSHIPLANS.includes(field)) {
              if (field) {
                let value;
                if (field === 'created_at' || field === 'start_date') {
                  value = plan[field]
                    ? moment(plan[field]).format('LLLL')
                    : '-';
                } else if (field === 'min_price') {
                  value = plan[field] === 0 ? 'free' : plan[field];
                } else if (typeof plan[field] === 'boolean') {
                  if (plan[field]) {
                    value = (
                      <span style={{ color: 'green' }}>
                        {plan[field].toString()}
                      </span>
                    );
                  } else {
                    value = (
                      <span style={{ color: 'red' }}>
                        {plan[field].toString()}
                      </span>
                    );
                  }
                } else if (field === 'type') {
                  if (plan[field] === 'custom') {
                    value = plan['duration_months'] + ' Months';
                  } else if (plan[field] === 'custom') {
                    value = plan['start_at'] + ' ' + plan['end_at'];
                  } else {
                    value = plan[field];
                  }
                } else if (field === 'price') {
                  if (plan['free']) {
                    value = 'free';
                  } else {
                    value = plan['amount'] + ' ' + plan['currency'];
                  }
                } else if (field === 'actions') {
                  return (
                    <TableCell key={index}>
                      <EditButtonContainer>
                        <Link to={`/plans/${plan.id}/edit`}>
                          <Button variant="outlined" color="primary">
                            Edit
                          </Button>
                        </Link>
                      </EditButtonContainer>
                    </TableCell>
                  );
                } else {
                  value = plan[field];
                }
                return <TableCell key={index}>{value}</TableCell>;
              }
            }
            return null;
          })}
        </TableRow>
      );
    });
  };

  renderTable = () => {
    const { ui } = this.props;
    if (ui === 'complete') {
      return (
        <EventsTable>
          <EventsTableHead>
            <TableRow>{this.renderTableCellNames()}</TableRow>
          </EventsTableHead>
          <TableBody>{this.renderTableBody()}</TableBody>
        </EventsTable>
      );
    }

    return null;
  };

  renderEmpty = () => (this.props.ui === 'empty' ? <Empty /> : null);

  render() {
    return (
      <div>
        <TextField
          id="search"
          label="Search by Name"
          type="search"
          margin="normal"
          onChange={e => this.onChangeSearch(e.target.value)}
          onKeyPress={this.onEnter}
        />
        <SearchButton
          variant="contained"
          color="primary"
          onClick={() => this.onClickSearchEvent()}
        >
          Search
        </SearchButton>
        <TableContainer>
          <TablePaper>
            {this.renderTable()}
            {this.renderEmpty()}
          </TablePaper>
        </TableContainer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  membershiplans: state.membership.membershiplans,
  ui: state.ui.uiState
});

const ActionCreators = Object.assign(
  {},
  MembershiPlansActionCreators,
  UiActionsCreators
);

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(ActionCreators, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemberShipPage);



// WEBPACK FOOTER //
// ./src/pages/membershipPage/index.js